import { useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'
import styled from 'styled-components'

import { reatomFollowersFilter } from '@root/features/user/user-connections'
import { UsersSearch } from '@root/features/user/users-search/ui/users-search'

import { RelationFollowers } from './relation-followers'

import type { DelugeId } from '@root/entities/user-short'

type RelationFollowersFilterProps = {
  delugeId: DelugeId
}

export const RelationFollowersFilter = ({
  delugeId,
}: RelationFollowersFilterProps) => {
  const followersFilter = useMemo(
    // eslint-disable-next-line @reatom/unit-naming-rule
    () => reatomFollowersFilter(delugeId),
    [delugeId],
  )

  const [searchQuery, setSearchQuery] = useAtom(followersFilter.searchQueryAtom)

  return (
    <Root>
      <Head>
        <UsersSearch
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
      </Head>
      <RelationFollowers followersFilter={followersFilter} />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  padding: 0 16px 12px;
  overflow: auto;
`

const Head = styled.div`
  z-index: 1;
  position: sticky;
  top: 0;
  padding-bottom: 12px;
  background: var(--background-1);
`
